import { useEffect } from "react";
import AppHeader from "./AppHeader";
import { Link } from "react-router-dom";
import { getUserRole } from "./auth-utils";

/**
 * @param {Object} props
 * @param {string} props.title
 * @param {string} props.documentTitle
 * @param {string} props.className
 * @param {boolean} props.showTranslator
 * @param {Object[]} props.navBar
 * @param {boolean} props.external
 */
export default function Page({ title, documentTitle = title, className = "", showTranslator = false, navBar = [], external, children }) {
    useEffect(() => void (document.title = `${documentTitle} - SmarterMe® Portal`), [documentTitle]);

    return (
        <div className={`app-page ${getUserRole() === "FAMILY" ? "family-user" : ""} ${className}`}>
            <AppHeader pageTitle={title} navBarContents={navBar} showTranslator={showTranslator} />
            {children}
            <footer className="bg-(--ngf-dark-blue) text-white py-3 px-2 mt-auto flex flex-wrap gap-3 justify-content-center align-items-center text-sm font-light">
                <p className="mb-0">
                    Copyright © {new Date().getFullYear()} Next Generation Focus, Inc.
                </p>
                <div className="flex flex-wrap gap-3 justify-content-center align-items-center">
                    <Link to="/privacy" className="text-decoration-underline text-white">Privacy Policy</Link>
                    <Link to="/mobile-tos" className="text-decoration-underline text-white">Mobile Terms of Service</Link>
                </div>
            </footer>
        </div>
    );
}